import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { getSupabaseClient } from "./Database/supabaseClient";
import UserViewSection from "./Sections/UserViewSection";
import LoadingScreen from "./Helpers/LoadingScreen"; // Custom loading screen using three.js

// Get the Supabase client
const supabase = getSupabaseClient();

const ProfilePage = () => {
  const { username } = useParams(); // Get the username from the URL
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);

  const formatUsername = (displayName) => {
    if (!displayName) return null;
    return displayName.toLowerCase().replace(/\s+/g, "_");
  };

  // Function to fetch profile data from the database
  const fetchProfileData = useCallback(async (username) => {
    const formattedUsername = formatUsername(username);

    try {
      const { data } = await supabase
        .from("users") // Replace with your table name
        .select("*")
        .eq("user_name", formattedUsername) // Replace with your column name
        .single();

      setProfileData(data); // Set the profile data if the user exists
    } finally {
      setLoading(false); // Stop loading
    }
  }, []);

  // Fetch the profile data when the component mounts
  useEffect(() => {
    if (username) {
      fetchProfileData(username);
    }
  }, [username, fetchProfileData]);

  // Render loading state with 3D animation
  if (loading) {
    return <LoadingScreen />;
  }

  // Render profile page if user is found
  return (
    <>
      <UserViewSection profileData={profileData} selectedTemplate="template" />
    </>
  );
};

export default ProfilePage;
